export default __webpack_public_path__ + "images/TELAVIVAIR.4523290.png";